import { render, staticRenderFns } from "./updateStore.vue?vue&type=template&id=2f5ab100"
import script from "./updateStore.vue?vue&type=script&lang=js"
export * from "./updateStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports